'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const StarsChartInner = dynamic(() => import('./StarsChartInner'), { ssr: false });

export default function StarsChart() {
  return (
    <div className="px-4 py-4">
      <h2 className="text-foreground font-bold text-base mb-3">Aylık Yıldız Kazanımı</h2>
      <StarsChartInner />
    </div>
  );
}